module.exports = __webpack_public_path__ + "img/store_timing.aae3862e.jpg";